import React from 'react';
/**
 * Gen 3 SEO-friendly category description block. Marked with
 * `category-description` / `wf-category-description` so the WebsiteForge
 * importer can populate this region dynamically.
 */
export function Description() {
  return <div className="category-description wf-category-description mb-12 max-w-4xl" data-id="element-582">
      <div className="prose prose-gray text-gray-700 text-base sm:text-lg leading-relaxed" data-id="element-583">
        The newest generation of Daedo electronic scoring gear. Gen 3 introduces
        redesigned transmitters, improved hit-detection accuracy, and
        tournament-ready performance trusted at the highest levels of
        competition.
      </div>
    </div>;
}